function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  "ng-attr-r": "{{config.radius}}",
  "ng-attr-stroke-width": "{{config.width}}",
  "ng-attr-stroke": "{{config.stroke}}",
  "ng-attr-stroke-dasharray": "{{config.dasharray}}",
  fill: "none",
  strokeLinecap: "round",
  r: 30,
  strokeWidth: 6,
  stroke: "#5f6fff",
  strokeDasharray: "47.12388980384689 47.12388980384689",
  transform: "rotate(193.846 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  calcMode: "linear",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "2.6s",
  begin: "0s",
  repeatCount: "indefinite"
}));

var SvgLoaderLightBlue = function SvgLoaderLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-dual-ring",
    style: {
      background: "none"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoaderLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader-light-blue.63fdfdbe.svg";
export { ForwardRef as ReactComponent };